module.exports = __webpack_public_path__ + "7c0ec22601bd7d7773ca1a2e13ecb793.png";


//////////////////
// WEBPACK FOOTER
// ../server/public/static/images/moma/nav-light-left.png
// module id = 712
// module chunks = 0 1 2 3 4 5